import { useMutation, useQuery } from "@tanstack/react-query";
import { Constants } from "../../../assets/utils/lib/constants";
import { CommunityNeighborhoodDto } from "../../../services/dto";
import { IActionResult } from "../../../services/proxies";
import { CommunityNeighborhoodClient } from "../../../services/proxies/community/communityNeighborhoodClient";

export const communityNeighborhoodQueryKeys = {
  all: "communityNeighborhoodsQuery",
  detail: "communityNeighborhoodQuery",
};

export namespace CommunityNeighborhoodService {
  const client = new CommunityNeighborhoodClient();

  export const getAll = (communityId: string) => useQuery({
    queryKey: [communityNeighborhoodQueryKeys.all, communityId],
    queryFn: async () => await client.getCommunityNeighborhoodsAsync(communityId),
    enabled: Boolean(communityId) && communityId !== Constants.emptyGuid,
  });

  export const get = (id: string | undefined) => useQuery({
    queryKey: [communityNeighborhoodQueryKeys.detail, id],
    queryFn: async () => await client.getCommunityNeighborhoodAsync(id!),
    enabled: Boolean(id) && id !== Constants.emptyGuid,
  });

  export const save = () => useMutation<IActionResult<CommunityNeighborhoodDto>, Error, CommunityNeighborhoodDto>({
    mutationFn: async (payload) => await client.saveCommunityNeighborhoodAsync(payload),
  });
}
